import o from "./Input.mjs";
import "../../../jsx-runtime-c20f6c15.mjs";
import "react";
import "clsx";
import "../../../shared/icons/i-close-x.svg.mjs";
export {
  o as default
};
